import { PATIENT_PATHS } from '@/utilities/paths'
import {
  markKitRegistrationReturnKitIdForResume,
  persistKitRegistrationReturnKitIdFromSearch,
} from '@/utilities/auth/kitRegistrationReturnKitId'
import { persistSampleCollectionReturnKitIdFromSearch } from '@/utilities/auth/sampleCollectionReturnKitId'

/**
 * Builds the query string to keep on a patient return path after session expiry.
 * Kit ids stay in session storage, not the URL. Sample collection keeps instruction_id only.
 */
export function buildPatientSessionReturnSearch(pathname: string, search: string): string {
  if (pathname === PATIENT_PATHS.flows.kitRegistrationFirstStep) {
    persistKitRegistrationReturnKitIdFromSearch(search)
    markKitRegistrationReturnKitIdForResume()
    return ''
  }

  if (pathname.startsWith(PATIENT_PATHS.flows.sampleCollection)) {
    persistSampleCollectionReturnKitIdFromSearch(search)
    const instructionId = new URLSearchParams(search).get('instruction_id')
    if (!instructionId) return ''
    const kept = new URLSearchParams()
    kept.set('instruction_id', instructionId)
    return `?${kept.toString()}`
  }

  return ''
}
